export const guestOrderTrackingErrors = {
  orderNumberNotFound: 'Please provide your order number.',
  onlineOrdersInvalidFormat:
    'For online orders, this starts with either the letter W or C.',
  instoreOrdersInvalidFormat:
    'For in-store orders, this starts with the letter H.',
  phoneNumberNotFound: 'Please provide your 10 digit phone number.',
  emailInvalidFormat: 'Please provide your email, formatted as you@domain.com',
  tryAgainPhone:
    "We're sorry. We couldn't find that order and phone number combination. Please try re-entering your order number and phone number",
  tryAgainEmail:
    "We're sorry. We couldn't find that order and email combination. Please confirm your order number and your email address. You can find your order number in your order confirmation email.",
};
